import React from "react";

// A persistent, very subtle field of flowing curved lines + movement words that
// lives BEHIND the content on every page. Words are anchored to the outer edges
// and zoom outward (away from the central reading column) so they never clash
// with the copy the customer is reading. Purely decorative / atmospheric.
const STROKES = [
  "M-50,260 C 220,120 420,480 680,300 S 1120,120 1520,320",
  "M-50,520 C 260,640 540,280 840,480 S 1300,700 1600,460",
  "M120,-40 C 240,220 140,480 380,660",
  "M1360,-20 C 1220,240 1340,520 1100,720",
];

export function AmbientMovement() {
  return (
    <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none" aria-hidden="true">
      <svg className="ambient-lines absolute inset-0 h-full w-full opacity-70" viewBox="0 0 1440 760" preserveAspectRatio="xMidYMid slice">
        {STROKES.map((d, i) => (
          <path key={i} d={d} fill="none" stroke="url(#ambient-grad)" strokeWidth={2.5} strokeLinecap="round" opacity={0.65} />
        ))}
        <defs>
          <linearGradient id="ambient-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#5BC8FF" stopOpacity="0.85" />
            <stop offset="55%" stopColor="#8FB4FF" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#23B4C4" stopOpacity="0.8" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

export default AmbientMovement;
